"use client";

import { useState } from "react";
import useLocaleLegacy from "@/hooks/use-locale-legacy";
import locale from "@/locales/unit-type.json";

export interface VirtualTourListProps {
  content: {
    id: string;
    title: string;
    link: string;
  }[];
}

export default function VirtualTourList(props: VirtualTourListProps) {
  const { t } = useLocaleLegacy(locale);
  const [activeData] = useState(
    () =>
      props.content.filter((content) =>
        content.title.toLowerCase().includes("3 br")
      )[0]
  );

  return (
    <div id="virtual-list" className="pb-8 xl:pb-16 pt-6 xl:pt-13 mt-16 xl:mt-36 -scroll-m-10">
      <div className="w-full xl:max-w-screen-lg mx-auto">
        <h1 className="xl:text-5xl text-center mb-8 font-pluto text-brown">
          {t("virtual_tour_title")}
        </h1>

        <iframe
          src={activeData.link}
          loading="lazy"
          width="100%"
          className="rounded-[9px] xl:rounded-[20px] h-[194px] xl:h-[500px]"
        ></iframe>

        <div className="w-full text-center mt-4 xl:mt-8 ">
          <button className="font-pluto text-[10px] xl:text-[32px] rounded-[15px] xl:rounded-[53px] bg-gold text-white font-medium px-4 xl:px-6 py-1 xl:py-2">
            3 BR+
          </button>
        </div>
      </div>
    </div>
  );
}
